(function(window) { var svs = window.svs || {}; svs.modules = svs.modules || []; if(svs.modules.indexOf('/components/accountservices-react/deposit/assets/react/swedbank-express/pages/deposit/express-deposit.js') >= 0) return;  svs.modules.push('/components/accountservices-react/deposit/assets/react/swedbank-express/pages/deposit/express-deposit.js');
'use strict';

function _slicedToArray(r, e) { return _arrayWithHoles(r) || _iterableToArrayLimit(r, e) || _unsupportedIterableToArray(r, e) || _nonIterableRest(); }
function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(r, a) { if (r) { if ("string" == typeof r) return _arrayLikeToArray(r, a); var t = {}.toString.call(r).slice(8, -1); return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? _arrayLikeToArray(r, a) : void 0; } }
function _arrayLikeToArray(r, a) { (null == a || a > r.length) && (a = r.length); for (var e = 0, n = Array(a); e < a; e++) n[e] = r[e]; return n; }
function _iterableToArrayLimit(r, l) { var t = null == r ? null : "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"]; if (null != t) { var e, n, i, u, a = [], f = !0, o = !1; try { if (i = (t = t.call(r)).next, 0 === l) { if (Object(t) !== t) return; f = !1; } else for (; !(f = (e = i.call(t)).done) && (a.push(e.value), a.length !== l); f = !0); } catch (r) { o = !0, n = r; } finally { try { if (!f && null != t.return && (u = t.return(), Object(u) !== u)) return; } finally { if (o) throw n; } } return a; } }
function _arrayWithHoles(r) { if (Array.isArray(r)) return r; }
const _svs$ui$ReactGrid = svs.ui.ReactGrid,
  Grid = _svs$ui$ReactGrid.Grid,
  GridCol = _svs$ui$ReactGrid.GridCol,
  GridRow = _svs$ui$ReactGrid.GridRow;
const DepositInfo = svs.accountservicesReact.deposit.swedbankExpress.sharedComponents.DepositInfo;
const _svs$accountservicesR = svs.accountservicesReact.deposit.depositShared,
  OnboardingDepositAmountInfo = _svs$accountservicesR.OnboardingDepositAmountInfo,
  DepositInput = _svs$accountservicesR.DepositInput,
  DepositButton = _svs$accountservicesR.DepositButton;
const _svs$ui$reactForm = svs.ui.reactForm,
  Form = _svs$ui$reactForm.Form,
  ControlGroup = _svs$ui$reactForm.ControlGroup,
  Select = _svs$ui$reactForm.Select,
  Option = _svs$ui$reactForm.Option;
const Button = svs.ui.ReactButton;
const showChangeBankQuestionAsync = svs.accountservicesReact.deposit.dialogs.swedbankExpressDialogs.showChangeBankQuestionAsync;
const amountChangeAction = svs.accountservicesReact.deposit.store.deposit.actions.amountChangeAction;
const ExpressDeposit = _ref => {
  let accountList = _ref.accountList,
    bankName = _ref.bankName,
    isPlayerRegistration = _ref.isPlayerRegistration,
    onClickChangeBank = _ref.onClickChangeBank,
    onClickDeposit = _ref.onClickDeposit;
  const _React$useState = React.useState('-1'),
    _React$useState2 = _slicedToArray(_React$useState, 2),
    selectedBankAccount = _React$useState2[0],
    setSelectedBankAccount = _React$useState2[1];
  const amount = ReactRedux.useSelector(state => state.deposit.amount);
  const _React$useState3 = React.useState(false),
    _React$useState4 = _slicedToArray(_React$useState3, 2),
    noBankAccountSelected = _React$useState4[0],
    setNoBankAccountSelected = _React$useState4[1];
  const _React$useState5 = React.useState(true),
    _React$useState6 = _slicedToArray(_React$useState5, 2),
    showBankName = _React$useState6[0],
    setShowBankName = _React$useState6[1];
  const dispatch = ReactRedux.useDispatch();
  const instantPay = ReactRedux.useSelector(state => state.deposit.instantPay);
  const maxLimitLeft = ReactRedux.useSelector(state => {
    var _state$deposit$maxLim;
    return (_state$deposit$maxLim = state.deposit.maxLimits) === null || _state$deposit$maxLim === void 0 ? void 0 : _state$deposit$maxLim.spendLimitRemaining;
  });
  React.useEffect(() => {
    const hasInstantPayAmount = svs.accountservicesReact.deposit.helpers.sharedHelpers.hasInstantPayAmount;
    const recentBankAccount = accountList && accountList.filter(a => a.recent === 1);
    if (recentBankAccount.length > 0) {
      setSelectedBankAccount(recentBankAccount[0].bban);
    }
    if (bankName && bankName.length > 2) {
      setShowBankName(true);
    }
    if (hasInstantPayAmount(instantPay)) {
      dispatch(amountChangeAction(instantPay === null || instantPay === void 0 ? void 0 : instantPay.amount));
    }
  }, [accountList, bankName, instantPay, dispatch]);
  const handleChangeBank = async () => {
    try {
      await showChangeBankQuestionAsync();
      onClickChangeBank();
    } catch (_unused) {
    }
  };
  const handleOnChangeBankAccount = e => {
    setNoBankAccountSelected(false);
    setSelectedBankAccount(e.target.value);
  };
  const handleSubmitDeposit = (e, _formData, isValid) => {
    e && e.preventDefault();
    e && e.stopPropagation();
    if (selectedBankAccount === '-1') {
      setNoBankAccountSelected(true);
      return;
    }
    if (!isValid) {
      return;
    }
    setSelectedBankAccount(selectedBankAccount);
    onClickDeposit({
      accountNumber: selectedBankAccount,
      amount,
      maxLimitLeft
    });
  };
  return React.createElement("div", {
    className: "margin-top-2"
  }, showBankName && React.createElement(Grid, null, React.createElement(GridRow, null, React.createElement(GridCol, {
    xs: 8
  }, React.createElement("div", null, React.createElement("div", null, "Vald bank"), React.createElement("div", {
    className: "h4"
  }, bankName))), React.createElement(GridCol, {
    xs: 4
  }, React.createElement("div", {
    className: "align-right"
  }, React.createElement(Button, {
    onClick: handleChangeBank,
    transparent: true
  }, " Byt bank"))))), React.createElement(Form, {
    method: "post",
    onSubmit: (e, formData, isValid) => {
      handleSubmitDeposit(e, formData, isValid);
    }
  }, React.createElement(ControlGroup, {
    errorMessage: "Du m\xE5ste ange ett bankonto",
    hasError: noBankAccountSelected,
    idForInput: "bankaccountslist",
    v2: true
  }, React.createElement(Select, {
    id: "bankaccountslist",
    label: "Bankkonto",
    onChange: e => handleOnChangeBankAccount(e),
    v2: true,
    value: selectedBankAccount
  }, React.createElement(Option, {
    disabled: true,
    value: "-1"
  }, "V\xE4lj ett bankkonto"), accountList && accountList.length > 0 && accountList.map(ac => React.createElement(Option, {
    key: ac.bban,
    value: ac.bban
  }, ac.name, ' ', ac.bban)))), React.createElement(DepositInput, null), isPlayerRegistration && React.createElement(OnboardingDepositAmountInfo, {
    depositAmount: amount
  }), React.createElement(DepositButton, null)), React.createElement(DepositInfo, null), !showBankName && React.createElement("div", null, "Om du har fler banker s\xE5 kan du byta bank", ' ', React.createElement("a", {
    onClick: handleChangeBank
  }, "h\xE4r")));
};
svs.accountservicesReact.deposit.swedbankExpress.pages.deposit.ExpressDeposit = ExpressDeposit;

 })(window);